<template>
  <section class="w-full px-8 py-6 mb-4 bg-white wrapper-bar-chart">
    <h1 class="mb-2 md:text-xl">Need Approval</h1>
    <section class="w-full overflow-x-auto bg-white custom-scrollbar">
      <table class="w-full pb-4 mt-6 bg-white min-w-max">
        <thead class="text-gray-400 bg-white border-b border-gray-200">
          <tr>
            <th class="text-sm text-left">Request Name</th>
            <th class="text-sm text-left">Employee List</th>
          </tr>
        </thead>
        <tbody v-if="needApprovals.length">
          <tr
            class="border-b h-max"
            v-for="(needApproval, i) in needApprovals"
            :key="i"
          >
            <td class="p-3 text-sm">
              <p class="text-sm text-gray-400">
                {{ needApproval?.type }}
              </p>
            </td>
            <td
              class="flex items-center p-3 text-sm"
              v-if="
                showModeList === 'profile' ||
                (showModeList === 'full' &&
                  showModeListIdx !== needApproval.type)
              "
              @click="
                showModeList = 'full';
                showModeListIdx = needApproval?.type;
              "
            >
              <template v-if="needApproval?.data?.length > 0">
                <div
                  class="flex items-center justify-center w-12 h-12 duration-300 border-2 border-white rounded-full shadow-md cursor-pointer hover:z-10 hover:-mt-2 bg-zinc-400"
                  v-for="(request, i) in needApproval?.data"
                  :style="`transform:translateX(${
                    i !== 0 ? `-${i * 0.5}rem` : '0'
                  })`"
                  :key="i"
                >
                  <h2 class="text-white text-md">
                    {{
                      request?.emp_id?.emp_fullname.substr(0, 1) +
                      request?.emp_id?.emp_fullname.substr(
                        request?.emp_id?.emp_fullname.indexOf(" ") + 1,
                        1
                      )
                    }}
                  </h2>
                </div>
              </template>
              <p v-else class="flex items-center h-12 text-gray-400">
                No Employment Request
              </p>
            </td>
            <td
              class="p-3 text-sm"
              @click="
                showModeList = 'profile';
                showModeListIdx = needApproval.type;
              "
              v-else-if="
                showModeList === 'full' && showModeListIdx === needApproval.type
              "
            >
              <template v-if="needApproval?.data?.length > 0">
                <section
                  v-for="(request, i) in needApproval?.data"
                  :key="i"
                  class="flex items-center mb-2 cursor-pointer"
                >
                  <div
                    class="flex items-center justify-center w-12 h-12 rounded-full shadow-md bg-zinc-400"
                  >
                    <h2 class="text-white text-md">
                      {{
                        request?.emp_id?.emp_fullname.substr(0, 1) +
                        request?.emp_id?.emp_fullname.substr(
                          request?.emp_id?.emp_fullname.indexOf(" ") + 1,
                          1
                        )
                      }}
                    </h2>
                  </div>
                  <div class="ml-5">
                    <h1
                      class="text-base text-blue-400 cursor-pointer hover:opacity-70"
                      @click.stop="
                        assignDetailRequest(request, showModeListIdx)
                      "
                    >
                      {{ request?.emp_id?.emp_fullname }}
                    </h1>
                    <p class="mb-1 text-sm text-gray-400">
                      {{ request?.emp_id?.email }}
                    </p>
                  </div>
                </section>
              </template>

              <p v-else class="flex items-center h-12 text-gray-400">
                No Employment Request
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <NoDataShowing v-if="needApprovals.length === 0" />
    </section>
    <ModalLeave
      v-if="showModal === 'leave'"
      :title="'Response Log'"
      :show-modal="showModal"
      :detail-leave="detailLeave"
      @on-update-status="onUpdateStatus"
      @on-edit-status="onEditStatus"
      @on-close="closeModal"
    />
    <ModalNotLeave
      v-if="showModal === 'not_leave'"
      :title="'Response Log'"
      :show-modal="showModal"
      :detail-leave="detailLeave"
      :type-modal="typeModal"
      @on-close="closeModal"
      @on-update-hr-status="(value) => (detailLeave.overtime_hr.status = value)"
      @on-update-fsuperior-status="
        (value) => (detailLeave.overtime_fsuperior.status = value)
      "
      @on-update-ssuperior-status="
        (value) => (detailLeave.overtime_ssuperior.status = value)
      "
      @on-approval-employee="(value) => $emit('on-approval-employee', value)"
    />
  </section>
</template>

<script>
import ModalLeave from "./NeedApproval/ModalLeave.vue";
import NoDataShowing from "@/components/NoDataShowing.vue";
import ModalNotLeave from "./NeedApproval/ModalNotLeave.vue";
export default {
  name: "NeedApproval",
  components: {
    NoDataShowing,
    ModalLeave,
    ModalNotLeave,
  },
  props: {
    needApprovals: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showModeList: "profile",
      showModeListIdx: null,
      showModal: false,
      detailLeave: {},
      typeModal: "",
      data: {
        request_id: "",
        fsuperior: {
          fsuperior_id: {
            des_name: "",
          },
          status: "",
          approved_by: "",
          approved_date: "",
          approved_hours: "",
        },
        ssuperior: {
          ssuperior_id: {
            des_name: "",
          },
          approved_by: "",
          status: "",
          approved_date: "",
          approved_hours: "",
        },
        hr: {
          status: "",
          approved_by: "HR / Admin App",
          approved_date: "",
          approved_hours: "",
        },
      },
    };
  },
  methods: {
    assignDetailRequest(request, type) {
      this.showModal = type === "Leave Request" ? "leave" : "not_leave";
      this.typeModal = type;
      if (type === "Leave Request") {
        this.assignDetailLeaveRequest(request);
      } else if (type === "Overtime Request") {
        this.assignDetailOvertimeRequest(request);
      } else if (type === "Outside Assignment") {
        this.assignDetailOutsideRequest(request);
      } else if (type === "Change Offday") {
        this.assignDetailOffdayRequest(request);
      } else if (type === "Change Workshift") {
        this.assignDetailWorkshiftRequest(request);
      }
    },
    assignDetailLeaveRequest(request) {
      console.log(request);
      this.detailLeave = request;
    },
    assignDetailOvertimeRequest(request) {
      this.detailLeave = request;
    },
    assignDetailOutsideRequest(request) {
      this.detailLeave = request;
    },
    assignDetailOffdayRequest(request) {
      this.detailLeave = request;
    },
    assignDetailWorkshiftRequest(request) {
      this.detailLeave = request;
    },
    onUpdateStatus(value) {
      this.detailLeave.empleave_status = value;
    },
    onEditStatus(value) {
      this.$emit("on-edit-status", value);
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
